import ButtonWrap from '@/components/ButtonWrap';
import IconWrap from '@/components/IconWrap';

import './style.scss';

interface IActionButton {
    title: string;
    url?: string;
    icon?: React.ReactNode;
    exportCsv?: (data?: any) => void;
    isLoading?: boolean;
}
interface IProps {
    actions?: IActionButton[];
}

export const FooterLayout: React.FC<IProps> = ({ actions }) => {
    if (actions && actions.length === 0) return <></>;
    return (
        <div className="c-footer">
            <div className="c-footer__action">
                {actions?.length &&
                    actions.map(({ title, icon, exportCsv, isLoading = false }, index) => {
                        const iconProps = {
                            ...(icon && { icon: <IconWrap icon={icon} /> }),
                        };
                        return (
                            <ButtonWrap
                                key={index}
                                {...iconProps}
                                text={title}
                                type="default"
                                onClick={() => {
                                    exportCsv && exportCsv();
                                }}
                                isLoading={isLoading}
                            />
                        );
                    })}
            </div>
        </div>
    );
};
